export default {

    Permissions: 'Permission|Permissions',
};
